import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '@/lib/utils';

export const imageVariants = cva('object-cover transition-all duration-200', {
	variants: {
		size: {
			sm: 'w-16 h-16',
			md: 'w-24 h-24',
			lg: 'w-32 h-32',
			xl: 'w-48 h-48',
			full: 'w-full h-full',
		},
		rounded: {
			none: 'rounded-none',
			sm: 'rounded-sm',
			md: 'rounded-md',
			lg: 'rounded-lg',
			full: 'rounded-full',
		},
		border: {
			none: '',
			default: 'border border-gray-300 dark:border-gray-700',
			highlight: 'border-2 border-primary dark:border-primary-light',
		},
	},
	defaultVariants: {
		size: 'md',
		rounded: 'md',
		border: 'none',
	},
});

export interface ImageProps
	extends React.ImgHTMLAttributes<HTMLImageElement>,
		VariantProps<typeof imageVariants> {}

export const Image = React.forwardRef<HTMLImageElement, ImageProps>(
	({ className, size, rounded, border, ...props }, ref) => {
		return (
			<img
				ref={ref}
				className={cn(imageVariants({ size, rounded, border, className }))}
				{...props}
			/>
		);
	},
);

Image.displayName = 'Image';
